/** Tek kaynak: kargo / iade politikası — tüm sitede aynı sayılar kullanılsın. */
export const FREE_SHIPPING_THRESHOLD = 1500;
export const SHIPPING_COST = 200;
export const RETURN_DAYS = 7;
export const SHIPPING_DAYS_LABEL = '3-5 iş günü';

export function formatTl(n: number) {
  return n.toLocaleString('tr-TR');
}
